import type { NewsArticle } from "../../services/pulseService";
import { timeAgo } from "./utils";

interface Props {
  articles: NewsArticle[];
}

export function NewsFeed({ articles }: Props) {
  if (!articles.length) {
    return (
      <div className="glass-card p-4 sm:p-5">
        <h3 className="text-sm font-semibold text-surface-200 uppercase tracking-wider mb-3">
          Market News
        </h3>
        <p className="text-sm text-surface-500">No news available</p>
      </div>
    );
  }

  return (
    <div className="glass-card p-4 sm:p-5">
      <h3 className="text-sm font-semibold text-surface-200 uppercase tracking-wider mb-3">
        Market News
      </h3>
      <div className="space-y-3 max-h-[480px] overflow-y-auto custom-scrollbar">
        {articles.slice(0, 15).map((article) => (
          <a
            key={article.id}
            href={article.url}
            target="_blank"
            rel="noopener noreferrer"
            className="block p-3 rounded-xl hover:bg-surface-800/50 transition-colors border border-transparent hover:border-surface-700/50 group"
          >
            <div className="flex gap-3">
              {article.image && (
                <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-16 rounded-lg overflow-hidden bg-surface-800">
                  <img
                    src={article.image}
                    alt=""
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                    loading="lazy"
                    onError={(e) => { (e.target as HTMLImageElement).style.display = "none"; }}
                  />
                </div>
              )}
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-surface-100 line-clamp-2 group-hover:text-primary-400 transition-colors">
                  {article.headline}
                </h4>
                <div className="flex items-center gap-2 mt-1.5">
                  <span className="text-xs text-surface-500">{article.source}</span>
                  <span className="text-xs text-surface-600">•</span>
                  <span className="text-xs text-surface-500">{timeAgo(article.datetime)}</span>
                  {article.related && (
                    <>
                      <span className="text-xs text-surface-600">•</span>
                      <span className="text-xs text-primary-400/80 font-medium">
                        {article.related.split(",").slice(0, 3).join(", ")}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
